import { Button, Drawer, Form, Input, Row, Select, notification } from 'antd'
import './DrawerDefect.style.less'
import {
  DeleteOutlined,
  DoubleRightOutlined,
  EditOutlined,
} from '@ant-design/icons'
import { CLASSIFICATION } from '@/constant/status'
import { useEffect, useState } from 'react'

import { useMutation, useQuery } from 'react-query'
import {
  defectDetailRef,
  deleteDefectRef,
  getDefectAreaRef,
  updateDefectRef,
} from '../../InSpectionReport.service'

import { queryClient } from '@/config/react-query'
import { isEmptyValue, JSONStringify, parseJSON, toJson } from '@/utils/common'
import ModalConfirm from '@/components/ModalConfirm/ModalConfirm'
import { getCompanySetting } from '@/screens/SystemConfigure/UserManagment/UserManagment.transform'
import { getSingleTemplate } from '@/screens/SystemConfigure/TemplateManagement/template.transform'
import { COMPANY_SETTING_DEFECT_STATUS } from '@/constant/user'
import LoadingIndicator from '@/components/LoadingIndicator/LoadingIndicator'
import LoadingFingertip from '@/components/LoadingFingertip/LoadingFingertip'

interface Props {
  onClose: () => void
  open: boolean
  data: any
  index: number
  dataInspection?: any
}

function DrawerDefect(props: Props) {
  const onFinish = () => {}

  const [form] = Form.useForm()

  const classification = Form.useWatch('classification', form)

  const [isChange, setisChange] = useState(false)

  const [mouseOver, setMouseOver] = useState(false)

  const [items, setitems] = useState([])

  const [modalDeleteDefect, setModalDeleteDefect] = useState(false)

  const [defectList, setdefectList] = useState([])

  const { data: dataSetting } = useQuery(['defect_are_setting'], async () => {
    return await getCompanySetting('inspection', 'has_defect_area')
  })

  const { data: defectStatusCompanySetting } = useQuery(
    ['GET_COMPANY_SETTING_DEFECT_STATUS'],
    async () => {
      return await getCompanySetting('defect', COMPANY_SETTING_DEFECT_STATUS)
    }
  )

  const { data: dataDefectArea, isLoading: isLoadingDefectArea } = useQuery(
    ['get_defect_area', props.data?.id],
    async () => {
      const tmp =
        (await getDefectAreaRef())?.data?.data?.defect_lists?.map((item) => {
          return {
            label: item?.name,
            value: JSONStringify({
              label: item?.name,
              value: item?.id,
            }),
          }
        }) ?? []
      return tmp
    }
  )

  const { data: dataDetail, isLoading: isLoadingDefectDetail } = useQuery(
    ['defect_detail'],
    async () => {
      const data = (await defectDetailRef(props.data?.id)).data
      setitems(
        data?.items
          ? data?.items?.map((item) => {
              return {
                label: item?.label,
                value: JSONStringify(item),
              }
            })
          : [{ label: data?.item?.label, value: JSONStringify(data?.item) }]
      )
      const tmpList =
        data?.inspection?.order?.defect_group?.defect_lists?.map((item) => {
          return {
            label: `${item?.code} - ${item?.name}`,
            value: item?.id,
          }
        }) ?? []

      if (!tmpList.some((item) => item.value === data?.defect_list?.id)) {
        tmpList.push({
          label: `${
            !isEmptyValue(data?.defect_list?.code)
              ? `${data?.defect_list?.code} - `
              : ''
          } ${data?.defect_list?.name}`,
          value: data?.defect_list?.id,
        })
        setdefectList(tmpList)
      } else {
        setdefectList(tmpList)
      }
      return data
    },
    {
      enabled: props.open,
    }
  )

  const templateId = props?.dataInspection?.template?.id

  const { data: templateData } = useQuery(
    ['GET_TEMPLATE_DETAIL_FOR_DEFECT_DRAWER', templateId],
    async () => {
      return await getSingleTemplate(templateId)
    },
    {
      enabled: !!templateId,
    }
  )

  const templateDefectStatusOption = templateData?.option?.defect_status

  const isDefectStatusEnabled =
    Boolean(defectStatusCompanySetting?.value?.status) &&
    Boolean(templateDefectStatusOption?.status)

  const defectStatusDropdownOptions = (
    templateDefectStatusOption?.options ?? []
  ).map((opt: string) => ({ label: opt, value: opt }))

  const approvedDropdownOptions = (
    defectStatusCompanySetting?.value?.approved ?? []
  ).map((opt: string) => ({ label: opt, value: opt }))

  useEffect(() => {
    if (props.open) {
      if (!isEmptyValue(dataDetail)) {
        if (!isLoadingDefectDetail && !isLoadingDefectArea) {
          const formValues: any = {
            defect_list_id: dataDetail?.defect_list?.id,
            classification: dataDetail?.classification,
            item: JSONStringify(dataDetail?.item),
            quantity: dataDetail?.quantity,
            defect_status: dataDetail?.option?.defect_status?.status || dataDetail?.defect_status,
            approved: dataDetail?.option?.defect_status?.approved,
          }
          if (dataSetting?.value?.status) {
            const currentDefectArea = dataDefectArea.find(
              (item) => item.label === dataDetail?.defect_area
            )
            formValues.defect_area = currentDefectArea
          }
          setTimeout(() => {
            form.setFieldsValue(formValues)
          }, 500)
        }
      } else {
        form.resetFields()
      }
    }
  }, [
    props.open,
    dataDetail,
    isLoadingDefectDetail,
    isLoadingDefectArea,
    dataSetting,
  ])

  useEffect(() => {
    const isOpenSelect = document.querySelector('.ant-select-open')
    const allowScrolling = !mouseOver && !isOpenSelect
    if (allowScrolling) {
      document.body.style.overflow = 'auto'
    } else {
      document.body.style.overflow = ''
    }
  }, [mouseOver])

  const onSave: any = useMutation(async () => {
    try {
      await form.validateFields()
      const value = form.getFieldsValue()
      const defectArea = parseJSON(value?.defect_area)
      const payload = {
        defect_list_id: value?.defect_list_id,
        classification: value?.classification,
        defect_area_id: defectArea?.value,
        defect_area: defectArea?.label,
        item: JSON.parse(value.item),
        quantity: Number(value?.quantity),
        ...(isDefectStatusEnabled
          ? {
              option: {
                ...dataDetail?.option,
                defect_status: {
                  ...dataDetail?.option?.defect_status,
                  status: value?.defect_status,
                  approved: value?.approved,
                },
              },
            }
          : {}),
      }
      await updateDefectRef(props.data?.id, payload)
      await queryClient.invalidateQueries(['GET_REPORT_DATA_HEADER'])
      await queryClient.invalidateQueries(['GET_REPORT_DATA'])
      setisChange(false)
      props.onClose()
    } catch (error: any) {
      if (error) {
        notification.error({
          message: error.message,
          duration: 4,
          placement: 'top',
        })
      }
    }
  })

  useEffect(() => {
    if (!props.open) {
      setisChange(false)
    }
  }, [props.open])

  const color = (result) => {
    return result == 'Critical'
      ? '#C03261'
      : result == 'Major'
      ? '#EF9747'
      : result == 'Minor'
      ? '#5B5B5B'
      : '#5B5B5B'
  }

  const deleteMutation = useMutation(async () => {
    await deleteDefectRef(props.data?.id)
  })

  useEffect(() => {
    if (deleteMutation.isError) {
      const err: any = deleteMutation.error
      notification.error({
        message: err.response?.data?.message,
        duration: 4,
        placement: 'top',
      })
    }
  }, [deleteMutation.isError])

  const onDelete = async () => {
    await deleteMutation.mutateAsync()
    setModalDeleteDefect(false)
    await queryClient.invalidateQueries(['GET_REPORT_DATA_HEADER'])
    await queryClient.invalidateQueries(['GET_REPORT_DATA'])
    props.onClose()
  }

  return (
    <Drawer
      title=""
      placement={'right'}
      closable={false}
      open={props.open}
      key={'right'}
      width={400}
      onMouseOver={() => {
        setMouseOver(true)
      }}
      onMouseLeave={() => setMouseOver(false)}
    >
      <div className="drawer-defect-container">
        <Button
          onClick={props.onClose}
          className="button-close"
          icon={<DoubleRightOutlined className="close-icon" />}
        />
        <Row align={'middle'} className="title-container">
          <EditOutlined /> <p>Edit Defect</p>
        </Row>
        <p className="section-name">{props?.index} </p>
        <Form
          form={form}
          onFinish={onFinish}
          autoComplete="off"
          onChange={() => {
            setisChange(true)
          }}
          layout="vertical"
        >
          {dataSetting?.value?.status && !isLoadingDefectArea && (
            <Form.Item name={'defect_area'} label="Area">
              <Select
                onChange={() => {
                  setisChange(true)
                }}
                placeholder="Area"
                options={dataDefectArea}
              />
            </Form.Item>
          )}
          {!isLoadingDefectDetail && (
            <Form.Item name={'defect_list_id'} label="Defect Name">
              <Select
                onChange={() => {
                  setisChange(true)
                }}
                placeholder="Defect Name"
                options={defectList}
              />
            </Form.Item>
          )}

          <Form.Item name={'classification'} label="Classification">
            <Select
              onChange={() => {
                setisChange(true)
              }}
              placeholder="Classification"
              style={{ color: color(classification) }}
            >
              {CLASSIFICATION.map((item) => {
                return (
                  <Select.Option
                    style={{ color: color(item.value) }}
                    key={item.label}
                    value={item.value}
                  >
                    {item.label}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name={'quantity'} label="Quantity">
            <Input type="number" size="large" placeholder="Comment" />
          </Form.Item>
          <Form.Item name={'item'} label="Item">
            <Select
              onChange={() => {
                setisChange(true)
              }}
              placeholder="Comment"
              options={items}
            />
          </Form.Item>
          {isDefectStatusEnabled && (
            <>
              <Form.Item name={'defect_status'} label="Defect Status">
                <Select
                  onChange={() => {
                    setisChange(true)
                  }}
                  placeholder="Select Defect Status"
                  options={defectStatusDropdownOptions}
                />
              </Form.Item>
              <Form.Item name={'approved'} label="Approved">
                <Select
                  onChange={() => {
                    setisChange(true)
                  }}
                  placeholder="Select Approved"
                  options={approvedDropdownOptions}
                />
              </Form.Item>
            </>
          )}
        </Form>

        <Row className="button-container">
          <Button
            onClick={() => setModalDeleteDefect(true)}
            size="large"
            className="delete"
            disabled={onSave.isLoading || deleteMutation.isLoading}
            icon={<DeleteOutlined />}
          />
          <Button
            disabled={onSave.isLoading || deleteMutation.isLoading}
            onClick={props.onClose}
            className="cancel"
            size="large"
          >
            Cancel
          </Button>
          <Button
            onClick={() => onSave.mutateAsync()}
            size="large"
            type="primary"
            disabled={onSave.isLoading || !isChange || deleteMutation.isLoading}
            loading={onSave.isLoading}
          >
            Save
          </Button>
        </Row>
      </div>

      {modalDeleteDefect && (
        <ModalConfirm
          content={
            <div>
              Are you sure you want to delete this defect? You won’t be able to
              access it anymore.
            </div>
          }
          onClose={() => setModalDeleteDefect(false)}
          title="Delete Defect"
          open={modalDeleteDefect}
          onOK={async () => await onDelete()}
          onCancel={() => setModalDeleteDefect(false)}
          cancelButtonText="No, Cancel"
          type="delete"
          confirmButtonText="Yes, Delete"
        />
      )}
    </Drawer>
  )
}

export default DrawerDefect
